import { module } from 'stereomodularjs';


export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            submit: 'submit'
        }
    }

    submit(e) {
        e.preventDefault();

        const fd = new FormData(this.el);
        fd.delete('type');
        let typeval = [];
        this.el.querySelectorAll('.js-type:checked').forEach((ele) => { typeval.push(ele.value) });
        if (typeval.length > 0) {
            fd.append('type', typeval.join(', '));
        }
        var additions = {
            "Page actuelle": location.href,
            "Page précédente": document.referrer,
            "lpdgform": "1"
        }
        for (var key in additions) {
            fd.append(key, additions[key]);
        }
        fetch('/', {
            method: "POST",
            credentials: "same-origin",
            body: fd,
        });
        document.querySelector('body').classList.add('overlay-active');
        document.querySelectorAll('.c-overlay-cta-form').forEach((ele) => { ele.style.display = 'none' });
        document.querySelector('.js-overlay-cta').classList.add('is-active');
        document.querySelector('.js-overlay-confirmation-evaluate').style.display = 'block';
    }


}
